export const updateUnSignedDocuments = (state, docs) => {
  return {
    ...state,
    docs,
  }
};
